module.exports = __webpack_public_path__ + "media/large/real_estate_homes_sale-58edbb08.jpeg";